export default __webpack_public_path__ + "fd9be21286757b8d62ff1e16d9573205.png";